import React, { Component } from 'react'
import { withRouter, Link } from "react-router-dom";
import { Container, Nav, Navbar, Button, Row, Col } from 'react-bootstrap'
import './_navbars.scss';

class ExamHistoryNavbar extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    render() {
        return (
            <Navbar bg="white" className="examtop-header header-top shadow-sm" expand="md">
                <Container>

                    <Navbar.Toggle aria-controls="basic-navbar-nav" />

                    <Navbar.Collapse id="basic-navbar-nav">
                        <Row className="w-100 align-items-center">

                            {/* Left column */}
                            <Col xs={4} className="text-start">
                                <Button
                                    variant="link"
                                    className="text-dark"
                                    onClick={() => this.props.history.goBack()}
                                >
                                    Go Back
                                </Button>
                            </Col>

                            {/* Center column */}
                            <Col xs={4} className="text-center">
                                <h6 className="title text-muted m-0">
                                    Question and Answers View
                                </h6>
                            </Col>

                            {/* Right column (empty for balance) */}
                            <Col xs={4} />

                        </Row>
                    </Navbar.Collapse>

                </Container>
            </Navbar>

        )
    }
}

export default withRouter(ExamHistoryNavbar);
